import React from 'react';
import { THREAD_PAGE_SIZE } from '../constants';
import { useSupportStore } from '../state/use-support-store';
import { hasActiveFilters } from '../utils';
import LoadingSpinner from '../../../components/LoadingSpinner';
import ThreadItem from './ThreadItem';

const ThreadList = ({ onSelect }) => {
  const { threads, threadsTotal, threadsLoading, threadsLoaded, threadsError, filters, page, setPage, selectedId } = useSupportStore();

  const totalPages = Math.max(1, Math.ceil(threadsTotal / THREAD_PAGE_SIZE));
  const filtered = hasActiveFilters(filters);

  const pageItems = [
    { key: 'prev', type: 'button', label: 'Назад', disabled: page <= 0 || threadsLoading, onClick: () => setPage(page - 1) },
    { key: 'page', type: 'text', label: `${page + 1} из ${totalPages}` },
    { key: 'next', type: 'button', label: 'Дальше', disabled: page + 1 >= totalPages || threadsLoading, onClick: () => setPage(page + 1) },
  ];

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto">
        {threadsLoading && !threads.length ? <LoadingSpinner loading style="flex items-center justify-center py-10" /> : null}

        {!threadsLoading && threadsError?.status !== 403 && threadsError?.error ? <p className="px-3 py-6 text-center text-sm text-red-500">{threadsError.error}</p> : null}

        {threadsLoaded && !threadsLoading && !threads.length && !threadsError ? (
          <p className="px-3 py-10 text-center text-sm text-gray-500">{filtered ? 'Ничего не найдено' : 'Обращений пока нет'}</p>
        ) : null}

        {threads.map((item) => (
          <ThreadItem key={item.id} item={item} selected={item.id === selectedId} onSelect={onSelect} />
        ))}
      </div>

      {totalPages > 1 ? (
        <div className="flex items-center justify-center gap-3 border-t border-gray-200 px-3 py-2 text-sm text-gray-600">
          {pageItems.map((item) =>
            item.type === 'text' ? (
              <span key={item.key}>{item.label}</span>
            ) : (
              <button key={item.key} type="button" disabled={item.disabled} onClick={item.onClick} className="disabled:text-gray-300">
                {item.label}
              </button>
            )
          )}
        </div>
      ) : null}
    </div>
  );
};

export default ThreadList;
